import { render, staticRenderFns } from "./CallMobileTasksCard.vue?vue&type=template&id=28daa79d"
import script from "./CallMobileTasksCard.vue?vue&type=script&lang=js"
export * from "./CallMobileTasksCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports